/* Tonee product page. Prices are rendered by Liquid into the page, so nothing
   here formats money - it only reads and moves strings that are already there. */
(function () {
  if (window.tnpPdp) return;
  window.tnpPdp = true;

  function init(root) {
    if (!root || root.dataset.tnpReady) return;
    root.dataset.tnpReady = '1';

    var form = root.querySelector('[data-tnp-form]');
    var tiers = [].slice.call(root.querySelectorAll('[data-tnp-tier]'));
    var qtyEl = root.querySelector('[data-tnp-qty]');
    var addBtn = root.querySelector('[data-tnp-add]');
    var addLabel = root.querySelector('[data-tnp-add-label]');
    var addPrice = root.querySelector('[data-tnp-add-price]');
    var plainly = root.querySelector('[data-tnp-plainly]');

    var LBL = root.getAttribute('data-add-label') || 'Add to cart';
    var LBL_SUB = root.getAttribute('data-add-label-sub') || 'Subscribe';
    var NOTE_ONCE = root.getAttribute('data-once-note') || '';
    var NOTE_SUB = root.getAttribute('data-sub-note') || '';

    /* Transcy wraps Liquid money output in its own span and can append an ISO
       code, so the data attributes may hold markup. Read them as plain text.
       Only used as a fallback now - see THE BUTTON READS THE PAGE below. */
    var scratch = document.createElement('div');
    function plain(html) {
      if (!html) return '';
      scratch.innerHTML = html;
      return (scratch.textContent || '').replace(/\b(USD|NZD|AUD|GBP|EUR|CAD|JPY|SEK|DKK|PLN)\b/g, '').trim();
    }

    /* Transcy also appends an ISO code to prices it rewrites in the DOM
       ("$24.00 USD"), scattered and unstyled. We strip every one of those from
       our money elements and keep watching, because Transcy rewrites them after
       load. The single controlled code we DO show is the badge below.

       WE REMEMBER THE CODE WE STRIPPED. It is the only honest statement of what
       currency is actually on screen: Shopify.currency.active is the SHOPIFY
       currency, which is not the same thing when Transcy is converting on the
       client. See the badge note below. */
    var ISO = /\s*\b(USD|NZD|AUD|GBP|EUR|CAD|JPY|SEK|DKK|CHF|SGD|HKD|AED|SAR|ILS|MXN|BRL|INR|TRY|PLN)\b\s*/g;
    var seenCur = '';
    function deIso(el) {
      if (!el) return;
      var t = el.textContent;
      ISO.lastIndex = 0;
      if (!t || !ISO.test(t)) { ISO.lastIndex = 0; return; }
      ISO.lastIndex = 0;
      var hit = t.match(ISO);
      if (hit && hit.length) {
        var code = hit[0].replace(/[^A-Z]/g, '');
        if (code) seenCur = code;
      }
      var next = t.replace(ISO, ' ').replace(/\s{2,}/g, ' ').trim();
      if (next !== t) el.textContent = next;
    }

    /* CURRENCY CODE FOR SHOPPERS OUTSIDE THE US (Kate, 29 Sep 2026: customers
       kept asking which currency they were being charged in). AUD, CAD and NZD
       all render as a bare "$", so the number alone is genuinely ambiguous.

       US shoppers see no code - USD is the unmarked default and adding it would
       just be noise on our biggest market. Everyone else gets ONE small code, on
       the add-to-cart price, which is the number they actually pay.

       IT FOLLOWS WHAT IS ON SCREEN, NOT WHAT SHOPIFY THINKS (4 Oct 2026). The
       badge used to print Shopify.currency.active and was created only when that
       was not USD. When Transcy converts on the client - NZ market, shopper
       viewing in USD - Shopify still says NZD while every price on the page is
       in dollars, so the badge labelled a US price "NZD". The code stripped off
       Transcy's own output is the truth, so that wins when we have it. The badge
       is now always built and showCur decides whether it is seen, because the
       mismatch runs in both directions.

       It is deliberately a SIBLING of [data-tnp-money], never a child: the ISO
       sweep above walks the textContent of those elements and would eat it. */
    var CUR = '';
    try { CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; } catch (e) {}
    var curBadge = null;
    if (addPrice && addPrice.parentNode) {
      curBadge = document.createElement('span');
      curBadge.className = 'tnp-cur';
      curBadge.style.cssText = 'margin-inline-start:.35em;font-size:.78em;font-weight:600;letter-spacing:.06em;opacity:.75';
      curBadge.hidden = true;
      addPrice.parentNode.insertBefore(curBadge, addPrice.nextSibling);
    }
    function curNow() { return seenCur || CUR; }
    function showCur(on) {
      if (!curBadge) return;
      var code = curNow();
      if (code && curBadge.textContent !== code) curBadge.textContent = code;
      curBadge.hidden = !on || !code || code === 'USD' ||
                        !(addPrice && (addPrice.textContent || '').trim());
    }

    /* ---- pack size ----

       THE BUTTON READS THE PAGE, NOT THE ATTRIBUTE (Kate, 4 Oct 2026: "theres
       mismatch pricing here, on the quantity selector its one currency then on
       the add to cart button its in NZD").

       Every row carries data-price, rendered once by Liquid. Transcy converts
       the prices that are IN THE DOM a second or two after load - it cannot
       touch a data- attribute. So the rows showed USD while the button, rebuilt
       from the attribute, still said NZD. Reproduced exactly: rows $23/$35/$44,
       button $77.49.

       So the button now copies the SELECTED ROW'S OWN RENDERED PRICE, which is
       whatever the shopper is actually looking at, whoever converted it. The
       attribute stays as the fallback for the first paint and for anyone with
       no conversion running at all.

       It also has to re-copy LATER, because Transcy converts after selectTier
       has already run on load - that is what the syncPrice call in the
       MutationObserver below is for. */
    function rowPrice(row) {
      var live = row.querySelector('.tnp-row__price');
      var txt = live ? (live.textContent || '').trim() : '';
      return txt || plain(row.getAttribute('data-price'));
    }
    function currentRow() {
      return tiers.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0];
    }
    /* THE BUTTON HAS TO ADD TWO RENDERED PRICES.

       Both the pack row and the add-on row are printed by Liquid and may then
       be converted by Shopify Markets or Transcy, so the only safe way to show
       a combined total is to parse what is actually on screen and re-print it
       in the same shape. Same parse-and-reprint approach as
       tn-pdp-perunit.js - the separators are read off the page, never
       assumed, because a German page renders 20,95 and AED renders Dhs. 20.95. */
    var upOn = false;
    var upVariant = null;
    var upQty = 1;
    var upLineText = null;

    function mSpec(txt) {
      var t = String(txt == null ? '' : txt).replace(/\s{2,}/g, ' ').trim();
      var m = t.match(/\d[\d.,\u00a0\u202f' ]*\d|\d/);
      if (!m) return null;
      var num = m[0];
      var dm = num.match(/([.,])(\d{1,2})$/);
      var decs = dm ? dm[2].length : 0;
      var intPart = dm ? num.slice(0, num.length - decs - 1) : num;
      var grp = (intPart.match(/[.,\u00a0\u202f' ]/) || [''])[0];
      var val = parseFloat(intPart.replace(/[.,\u00a0\u202f' ]/g, '') + (decs ? '.' + dm[2] : ''));
      if (!isFinite(val)) return null;
      return { pre: t.slice(0, m.index), post: t.slice(m.index + num.length),
               dec: dm ? dm[1] : '.', decs: decs, grp: grp, val: val };
    }

    function mFmt(sp, value) {
      var d = sp.decs >= 2 ? sp.decs : 2;
      var parts = Math.abs(value).toFixed(d).split('.');
      var i = parts[0];
      if (sp.grp) i = i.replace(/\B(?=(\d{3})+(?!\d))/g, sp.grp);
      return sp.pre + i + sp.dec + parts[1] + sp.post;
    }

    function withUpsell(text) {
      if (!upOn || !upLineText) return text;
      var a = mSpec(text), b = mSpec(upLineText);
      if (!a || !b) return text;
      return mFmt(a, a.val + b.val);
    }

    function syncPrice() {
      if (!addPrice) return;
      var row = currentRow();
      if (!row) return;
      var v = withUpsell(rowPrice(row));
      /* Only write when it actually changed, or the observer below retriggers
         itself forever. */
      if (v && addPrice.textContent !== v) addPrice.textContent = v;
      showCur(true);
    }

    var sweeping = false;
    function sweepIso() {
      if (sweeping) return;
      sweeping = true;
      [].slice.call(root.querySelectorAll('[data-tnp-money]')).forEach(deIso);
      sweeping = false;
    }
    sweepIso();
    try {
      new MutationObserver(function () { sweepIso(); syncPrice(); })
        .observe(root, { subtree: true, childList: true, characterData: true });
    } catch (e) {}

    function selectTier(row) {
      tiers.forEach(function (t) { t.setAttribute('aria-checked', t === row ? 'true' : 'false'); });
      if (qtyEl) qtyEl.value = row.getAttribute('data-qty') || '1';
      syncPrice();
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectTier(t); }
      });
    });
    var preset = tiers.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0];
    if (preset) selectTier(preset);

    /* ---- gallery ---- */
    var slides = [].slice.call(root.querySelectorAll('[data-tnp-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-tnp-thumb]'));
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () {
        slides.forEach(function (s, j) { s.classList.toggle('is-on', i === j); });
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      });
    });

    /* ---- subscription: opt-in only, never the default ---- */
    var subWrap = root.querySelector('[data-tnp-sub]');
    var subToggle = root.querySelector('[data-tnp-sub-toggle]');
    var freqWrap = root.querySelector('[data-tnp-freq]');
    var freqSel = root.querySelector('[data-tnp-freq-select]');
    var planInput = root.querySelector('[data-tnp-plan-input]');

    function syncPlan() {
      var on = !!(subToggle && subToggle.checked);
      if (subWrap) subWrap.classList.toggle('is-on', on);
      if (freqWrap) freqWrap.hidden = !on;
      if (planInput) planInput.value = on && freqSel ? freqSel.value : '';
      if (addLabel) addLabel.textContent = on ? LBL_SUB : LBL;
      if (plainly) {
        plainly.textContent = on ? NOTE_SUB : NOTE_ONCE;
        plainly.classList.toggle('is-sub', on);
      }
    }
    if (subToggle) {
      subToggle.checked = false;
      subToggle.addEventListener('change', syncPlan);
    }
    if (freqSel) freqSel.addEventListener('change', syncPlan);
    syncPlan();

    /* ---- VARIANT OPTIONS (Face, Boobs, Nipples) ----
       Only present when the section rendered selects, i.e. when the product has
       real options. Before this existed the form posted one hidden variant id
       and a shopper who picked Blonde String was silently sold Dark String.

       Matching is done against the JSON the section emits, not against the DOM,
       so an option value containing a comma or a quote cannot break it. */
    var optWrap = root.querySelector('[data-tnp-opts]');
    if (optWrap && form && addBtn) {
      var idInput = form.querySelector('[name="id"]');
      var selects = [].slice.call(root.querySelectorAll('[data-tnp-opt]'));
      var vJson = root.querySelector('[data-tnp-variants]');
      var variants = [];
      try { variants = JSON.parse(vJson.textContent); } catch (e) { variants = []; }
      var basePrice = Number(root.getAttribute('data-tnp-base-price') || 0);

      function matchVariant() {
        var want = selects.map(function (s) { return s.value; });
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          var ok = true;
          for (var j = 0; j < want.length; j++) {
            if (String(o[j]) !== String(want[j])) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      }

      /* The picker's own swatch. Rendered only when every variant has a photo
         (see the section), so there is nothing to fall back to and nothing to
         guess. Warmed on first use so changing colour does not blank it. */
      var swEl = root.querySelector('[data-tnp-swatch]');
      var swWarmed = false;
      function swWarm() {
        if (swWarmed || !swEl) return;
        swWarmed = true;
        var seen = {};
        for (var i = 0; i < variants.length; i++) {
          var u = variants[i].img;
          if (!u || seen[u]) continue;
          seen[u] = 1;
          var pre = new Image();
          pre.src = u;
        }
      }

      function applyVariant(picked) {
        var vr = matchVariant();
        if (swEl && vr && vr.img && swEl.getAttribute('src') !== vr.img) {
          swEl.setAttribute('src', vr.img);
        }

        /* Some option combinations simply do not exist as a variant. Say so
           rather than leaving a live button wired to the wrong product. */
        if (!vr) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          showCur(false);
          return;
        }

        /* A different price means all six pack tiles are now wrong, because
           Liquid priced them from the variant that rendered. Reload and let the
           server do the maths again rather than showing a price we cannot
           honour. Same-price variants - which is every Tonee product today -
           swap in place with no reload. */
        if (picked && basePrice && vr.price !== basePrice) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', vr.id);
            window.location.href = u.toString();
          } catch (e) {
            window.location.search = 'variant=' + vr.id;
          }
          return;
        }

        if (idInput) idInput.value = vr.id;
        addBtn.disabled = !vr.available;
        if (addLabel) {
          addLabel.textContent = vr.available
            ? ((subToggle && subToggle.checked) ? LBL_SUB : LBL)
            : 'Sold out';
        }
        showCur(vr.available);

        /* Keep the address bar honest so a copied link reopens the same choice. */
        if (picked) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', vr.id);
            window.history.replaceState({}, '', url);
          } catch (e) {}
        }
      }

      selects.forEach(function (s) {
        /* Warm on the first touch of a picker, not at page load - these are
           extra requests on a page where speed is a stated priority, and
           nobody who never opens the picker needs them. */
        s.addEventListener('focus', swWarm, { once: true });
        s.addEventListener('change', function () { swWarm(); applyVariant(true); });
      });
      applyVariant(false);
    }

    /* ---- one-tick upsell (Kate, 6 Oct 2026) ----
       Boobs and Nipples sell each other. Ticking the box reveals that product's
       own colour and size selects and adds it as a SECOND cart line.

       Matching is done against the JSON the section emits, never by parsing the
       rendered text - exactly as the main picker does, and for the same reason:
       Nipples has an option value containing a double quote (10cm / 3.9") and
       Boobs has values with spaces and hyphens. */
    var upWrap = root.querySelector('[data-tnp-up]');
    if (upWrap) {
      var upToggle = upWrap.querySelector('[data-tnp-up-toggle]');
      var upBody = upWrap.querySelector('[data-tnp-up-body]');
      var upSelects = [].slice.call(upWrap.querySelectorAll('[data-tnp-up-opt]'));
      var upSingle = upWrap.querySelector('[data-tnp-up-single]');
      var upData = [];
      var upJson = upWrap.querySelector('[data-tnp-up-variants]');
      if (upJson) { try { upData = JSON.parse(upJson.textContent); } catch (e) { upData = []; } }

      /* SHOW THE COLOUR THEY ARE ACTUALLY BUYING.

         A native <select> cannot carry an image, so the only place the chosen
         colour can be seen is the row's own thumbnail. Once the add-on is
         ticked and the pickers are showing, the thumbnail becomes the selected
         variant's own photo; unticking puts the pack shot back, because a bare
         swatch on a collapsed row does not read as "Tonee Nipple Covers".

         The section only sets data-tnp-up-swatch when EVERY variant has a
         photo, so this never shows a real swatch for one colour and a pack
         shot for the next. */
      var upImg = upWrap.querySelector('.tnp-up__img');
      var upImgPack = upImg ? upImg.getAttribute('src') : null;
      var upSwatch = upImg && upWrap.hasAttribute('data-tnp-up-swatch');

      /* Warm every swatch the first time the add-on is opened. Swapping src on
         a cold cache leaves the thumbnail blank for a moment, which on a phone
         reads as a broken image at the exact moment someone is choosing a
         colour. One pass, distinct URLs only, and it never runs for a product
         without swatches. */
      var upWarmed = false;
      function upWarm() {
        if (upWarmed || !upSwatch) return;
        upWarmed = true;
        var seen = {};
        for (var i = 0; i < upData.length; i++) {
          var u = upData[i].img;
          if (!u || seen[u]) continue;
          seen[u] = 1;
          var pre = new Image();
          pre.src = u;
        }
      }

      /* The add-on's price follows its own quantity, off the figures Liquid
         printed, so the row and the button can never quote a number the cart
         will not charge. */
      var upQtyEl = upWrap.querySelector('[data-tnp-up-qty]');
      var upMinus = upWrap.querySelector('[data-tnp-up-minus]');
      var upPlus = upWrap.querySelector('[data-tnp-up-plus]');
      var upPriceEl = upWrap.querySelector('.tnp-up__price');
      var upPriceEls = [].slice.call(upWrap.querySelectorAll('[data-tnp-up-prices] [data-q]'));
      var upMax = upPriceEls.length ? Math.max.apply(null, upPriceEls.map(function (n) {
        return Number(n.getAttribute('data-q')) || 1;
      })) : 1;

      function upPriceFor(q) {
        for (var i = 0; i < upPriceEls.length; i++) {
          if (Number(upPriceEls[i].getAttribute('data-q')) === q) {
            return upPriceEls[i].textContent.replace(/\s{2,}/g, ' ').trim();
          }
        }
        return null;
      }

      function upShowQty() {
        if (upQty < 1) upQty = 1;
        if (upQty > upMax) upQty = upMax;
        if (upQtyEl) upQtyEl.textContent = String(upQty);
        if (upMinus) upMinus.disabled = upQty <= 1;
        if (upPlus) upPlus.disabled = upQty >= upMax;
        upLineText = upPriceFor(upQty);
        if (upPriceEl && upLineText && upPriceEl.textContent.trim() !== upLineText) {
          upPriceEl.textContent = upLineText;
        }
        syncPrice();
      }

      if (upMinus) upMinus.addEventListener('click', function () { upQty--; upShowQty(); });
      if (upPlus) upPlus.addEventListener('click', function () { upQty++; upShowQty(); });

      function upShowImg() {
        if (!upSwatch) return;
        var want = (upOn && upVariant && upVariant.img) ? upVariant.img : upImgPack;
        if (want && upImg.getAttribute('src') !== want) upImg.setAttribute('src', want);
      }

      function upPick() {
        if (upSingle) { upVariant = { id: Number(upSingle.value), available: true }; upShowImg(); return; }
        var chosen = upSelects.map(function (s) { return s.value; });
        upVariant = null;
        for (var i = 0; i < upData.length; i++) {
          var v = upData[i];
          if (!v.options || v.options.length !== chosen.length) continue;
          var same = true;
          for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { same = false; break; } }
          if (same) { upVariant = v; break; }
        }
        upShowImg();
      }

      if (upToggle) {
        upToggle.addEventListener('change', function () {
          upOn = upToggle.checked;
          if (upBody) upBody.hidden = !upOn;
          if (upOn) upWarm();
          upPick();
          syncPrice();
        });
      }
      upSelects.forEach(function (s) { s.addEventListener('change', upPick); });
      upPick();
      upShowQty();
    }

    /* ---- add to cart ---- */
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var main = {
          id: Number(form.querySelector('[name="id"]').value),
          quantity: Number(qtyEl && qtyEl.value ? qtyEl.value : 1)
        };
        if (planInput && planInput.value) main.selling_plan = Number(planInput.value);
        var original = addLabel ? addLabel.textContent : '';
        var note = root.querySelector('[data-tnp-error]');
        if (note) note.hidden = true;

        /* The single-item shape is kept when the upsell is off, so every page
           without one posts exactly what it posted before. Only the two-line
           case uses the items array - and selling_plan then has to sit on the
           item, because /cart/add.js ignores it at the top level there. */
        var body = main;
        if (upOn) {
          if (!upVariant || upVariant.available === false) {
            if (note) {
              note.textContent = 'That combination is not available. Choose another, or untick the add-on.';
              note.hidden = false;
            }
            return;
          }
          body = { items: [main, { id: Number(upVariant.id), quantity: upQty }] };
        }
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding...';
        if (addPrice) addPrice.hidden = true;
        showCur(false);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add to cart');
            if (addLabel) addLabel.textContent = 'Added';
            setTimeout(function () {
              if (addLabel) addLabel.textContent = original;
              if (addPrice) addPrice.hidden = false;
              showCur(true);
            }, 1400);
          })
          .catch(function (err) {
            if (addLabel) addLabel.textContent = original;
            if (addPrice) addPrice.hidden = false;
            showCur(true);
            if (note) { note.textContent = err.message; note.hidden = false; }
          })
          .then(function () { addBtn.disabled = false; });
      });
    }
  }

  /* Tap-to-play customer videos. Nothing downloads until a cover is tapped,
     and only one clip plays at a time. */
  function initVideos(sec) {
    if (!sec || sec.dataset.tnpVidsReady) return;
    sec.dataset.tnpVidsReady = '1';
    var playing = null;
    [].slice.call(sec.querySelectorAll('[data-tnp-vid]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-playing')) return;
        var tpl = btn.querySelector('[data-tnp-vid-src]');
        if (!tpl) return;
        if (playing && playing !== btn) {
          var other = playing.querySelector('video');
          if (other) other.pause();
          playing.classList.remove('is-playing');
        }
        var cover = btn.querySelector('.tnp-vid__cover');
        if (cover) cover.style.display = 'none';
        var existing = btn.querySelector('video');
        if (!existing) {
          btn.appendChild(tpl.content.cloneNode(true));
          existing = btn.querySelector('video');
        }
        btn.classList.add('is-playing');
        playing = btn;
        if (existing) {
          var pr = existing.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      });
    });
  }

  /* EVERY SHOP BUTTON ON THIS PAGE GOES BACK TO THE BUY PANEL (Kate, 22 Sep
     2026). There is no point sending someone from the comparison table or the
     stats band to a page they are already on, or off to the collection - the
     thing they want is at the top of this page.

     Matched on the visible label starting with "Shop", and only inside our own
     sections, so the header's Shop menu and anything in the footer are left
     alone. The href stays in the markup as the fallback: if this script never
     runs, the links still go somewhere sensible.

     The comparison section has its own scroll handler from an earlier round.
     Both end at the top of the page, so the two agreeing is harmless. */
  function initShopUp() {
    if (window.tnpShopUp) return;
    window.tnpShopUp = true;

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (!a.closest('.tnp, .tnh')) return;
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.indexOf('shop') !== 0) return;
      if (!document.querySelector('[data-tnp-root]')) return;
      e.preventDefault();
      try {
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      } catch (err) {
        window.scrollTo(0, 0);
      }
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-tnp-root]')).forEach(init);
    [].slice.call(document.querySelectorAll('[data-tnp-vids]')).forEach(initVideos);
    initShopUp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();